import queries from '@apis/queries';
import useUser from '@hooks/auth/useUser';
import { useQuery } from '@tanstack/react-query';

function useTestUser(): boolean {
    const { user } = useUser();
    const { status } = useQuery({
        ...queries.testUser.isTestUser(),
        enabled: !!user,
    });
    return status === 'success';
}

export default useTestUser;
